export { default as NodeEnv } from './application-environments';

export const AAC_FIT_NEW_FEATURES_LOADED = 'intro-widget-new-features-loaded';
